import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, first, tap, take } from 'rxjs/operators';
import { PromotionCodeEntityService } from '@views/pages/apps/general/promotion-codes/services/promotion-code-entity.service';

@Injectable()
export class PromotionCodeResolver implements Resolve<boolean> {

    constructor(private promotionCodeEntityService: PromotionCodeEntityService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.promotionCodeEntityService.loaded$.pipe(
          tap(loaded =>  {
            if(!loaded) {
              this.promotionCodeEntityService.getAll().pipe(
                take(1)
              );
            }
          }),
          filter(loaded => !!loaded),
          first()
        );
    }
}
